/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module NetworkSecurityPolicyModule */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { NetworkSecurityPolicyModalComponent } from 'ng/modules/network-security-policy';
import { NETWORK_SECURITY_POLICY_ITEM_TOKEN } from '../network-security-policy.tokens';

export type TNetworkSecurityPolicyCollection = typeof NetworkSecurityPolicyCollection;

/**
 * @description
 *
 * Collection for Network Security Policy
 *
 * @author Sarthak Kapoor
 */
export class NetworkSecurityPolicyCollection extends Collection {
    public static ajsDependencies = [
        NETWORK_SECURITY_POLICY_ITEM_TOKEN,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'networksecuritypolicy',
            permissionName: AviPermissionResource.PERMISSION_NETWORKSECURITYPOLICY,
            windowElement: NetworkSecurityPolicyModalComponent,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(NETWORK_SECURITY_POLICY_ITEM_TOKEN);
    }
}
